import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-purescript',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>PureScript icon</title><path d="M19.166 4.6l-1.24 1.24 3.97 3.97-3.97 3.97 1.24 1.24 4.58-4.6a.87.87 0 0 0 0-1.23zM6.955 6.74l1.87 1.75h8.23l-1.87-1.75zm-2.1 2.24l-4.6 4.6a.87.87 0 0 0 0 1.23l4.6 4.59 1.23-1.24-3.97-3.97 3.97-3.97-1.24-1.24zm3.97 2.14l-1.87 1.76h8.23l1.87-1.76zm-1.87 4.39l1.87 1.75h8.23l-1.87-1.75z"/></svg>`,
    styles: []
})
export class SimpleIconsPurescriptComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#14161A';
    @Input() className: string = 'simple-icons-purescript'
    constructor() {}
    ngOnInit(): void {}
}
